import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AppHelper} from "../../../helpers/app.helper";
import {UserService} from "../../../services/user.service";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  registerForm: FormGroup;

  registerSubmitted = false;

  @Input()
  formType: string;

  @Output()
  onRegisterSuccess = new EventEmitter();

  @Output()
  onGoToLogin = new EventEmitter();

  constructor(private formBuilder: FormBuilder, private userService: UserService) {}

  ngOnInit(): void {

    this.registerForm = this.formBuilder.group({
      name: ['', [ Validators.required, Validators.minLength(3) ]],
      email: ['', [ Validators.required, Validators.email ]],
      plainPassword: [ '', [ Validators.required, Validators.minLength(5)]],
      confirmPassword: [ '', [ Validators.required, this.sameValueValidator.bind(this) ]]
    });
  }

  async register() {

    this.registerSubmitted = true;
    if (this.registerForm.invalid) {

      return;
    }

    try {

      await this.userService.sendSolicitude(this.registerForm.value);
      await AppHelper.ShowAlertSuccess('Solicitud enviada', 'Pronto lo estaremos contactando para responderle.');

      this.registerForm.reset();
      this.registerSubmitted = false;
    } catch (e) {

      await AppHelper.ShowAlertError('Solicitud no enviada',
        (e.error && e.error.detail) ? e.error.detail : e.message, e);
    }

  }

  registerHasError(field, fieldError) {

    const control = this.registerForm.get(field);
    return this.registerSubmitted && control.errors && control.errors[fieldError];
  }

  sameValueValidator(control: AbstractControl) {

    const password = this.registerForm?.value.plainPassword;
    return password !== control.value ? { sameValue: { value: control.value } } : null;
  }

}
